// Shared mock customer, rep, and horse records for the design-approved
// screen ports. Represents Doug's actual world: real horse names, real
// 100X Equine SKUs, Nashville-area address for Sarah per the approved
// HTML. Not Lorem ipsum.
//
// TODO(runtime): swap mock -> real API calls once the following land:
//   - services/customer-identity GET endpoint
//   - services/hubspot-contact-source
//   - services/horse-timeline summarize call
//   - services/rep-availability getRepState call

export interface MockCustomer {
  id: string;
  initials: string;
  firstName: string;
  fullName: string;
  customerSince: string;
  city: string;
  stateCode: string;
  localTime: string;
  phone: string;
  email: string;
  // Display label for the preference card. Fixtures use the design
  // labels ('Text message' | 'Phone call' | 'Email'); a real contact
  // carries the HubSpot `preferred_channel` value (Text / Email / Call /
  // No Preference / Do Not Contact) or '' when unset, which IdentityRow
  // renders as "not set" (W38, 2026-10-20).
  preferredChannel: string;
}

export interface MockRep {
  id: string;
  initials: string;
  fullName: string;
  state: 'working' | 'break' | 'not_clocked_in' | 'stale';
}

export interface MockHorse {
  id: string;
  name: string;
  breed: string;
  age: string;
  discipline: string;
  product: string;
  routine: string;
  goal: string;
}

export const SARAH: MockCustomer = {
  id: 'contact_sarah_mitchell',
  initials: 'SM',
  firstName: 'Sarah',
  fullName: 'Sarah Mitchell',
  customerSince: 'April 2025',
  city: 'Nashville',
  stateCode: 'TN',
  localTime: '10:26 AM local',
  phone: '(615) 555-0148',
  email: 'sarah.mitchell@example.com',
  preferredChannel: 'Text message',
};

export const MICHAEL: MockCustomer = {
  id: 'contact_michael_thompson',
  initials: 'MT',
  firstName: 'Michael',
  fullName: 'Michael Thompson',
  customerSince: 'January 2024',
  city: 'Dallas',
  stateCode: 'TX',
  localTime: '9:26 AM local',
  phone: '(214) 555-0197',
  email: 'michael.thompson@example.com',
  preferredChannel: 'Phone call',
};

export const JAMIE: MockRep = {
  id: 'rep_jamie_dorsey',
  initials: 'JD',
  fullName: 'Jamie Dorsey',
  state: 'working',
};

export const DUKE: MockHorse = {
  id: 'horse_duke',
  name: 'Duke',
  breed: 'Quarter Horse',
  age: '9 years',
  discipline: 'Reining',
  product: 'Gut X',
  routine: 'Grain twice daily; free-choice hay',
  goal: 'Maintain condition during travel',
};

export interface MockOrderLine {
  name: string;
  qty: number;
  size: string;
}

export interface MockOrder {
  id: string;
  status: 'Delivered' | 'Processing' | 'Pending';
  lines: MockOrderLine[];
  subscriptionActive: boolean;
}

export const SARAH_ORDER: MockOrder = {
  id: 'EX-1042',
  status: 'Delivered',
  lines: [{ name: 'Gut X', qty: 1, size: '1 gallon' }],
  subscriptionActive: true,
};

// Base64 1x1 transparent png placeholder for images we moved out of inline.
// Downstream the real horse portrait and product jug images come from
// services/horse-timeline (horse portrait) and the Drive "01-product-jugs"
// library per reference_100x_equine_product_jugs.md.
export const HORSE_PORTRAIT_PLACEHOLDER =
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 90" preserveAspectRatio="xMidYMid slice">
      <defs>
        <linearGradient id="hp" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stop-color="#8a6b48"/>
          <stop offset="1" stop-color="#4a3a2a"/>
        </linearGradient>
      </defs>
      <rect width="80" height="90" fill="url(#hp)"/>
      <path d="M20 70 Q30 40 40 42 Q52 45 60 60 L60 80 L22 80 Z" fill="#2b2017" opacity="0.6"/>
      <circle cx="46" cy="42" r="4" fill="#1a1308"/>
    </svg>`,
  );
